import { put, select } from 'redux-saga/effects';
import { vehicleChangeStateAction, getVehicleNadaVid } from "../../vehicle";
import { AttributeKeyForVehicle } from '../enums';
export function* handleAttributesSetToVehicleSaga(action) {
    const normalizedAttributes = action.payload;
    let vehicleStateParam = [];
    let hasNadaVidMapped = false;
    //Update vehicle state for PIN, NADA, Redbook attribute if these are not ambigious
    if (normalizedAttributes.pinAttributes && normalizedAttributes.pinAttributes.allIds.length === 1) {
        const pinVid = normalizedAttributes.pinAttributes.allIds[0];
        const pinAttribute = normalizedAttributes.pinAttributes.byId[pinVid];
        vehicleStateParam.push({ name: AttributeKeyForVehicle.PIN_VID, value: pinVid });
        pinAttribute.sourceVid &&
            vehicleStateParam.push({ name: AttributeKeyForVehicle.SOURCE_VID, value: pinAttribute.sourceVid });
        pinAttribute.styleId &&
            vehicleStateParam.push({ name: AttributeKeyForVehicle.STYLE_ID, value: pinAttribute.styleId });
    }
    //Update vehicle state for NADA attribute if these are not ambigious
    if (normalizedAttributes.nadaAttributes && normalizedAttributes.nadaAttributes.allIds.length === 1) {
        const nadaVid = normalizedAttributes.nadaAttributes.allIds[0];
        const existingNadaVid = yield select(getVehicleNadaVid);
        if (nadaVid !== existingNadaVid) {
            hasNadaVidMapped = true;
        }
        vehicleStateParam.push({ name: AttributeKeyForVehicle.NADA_VID, value: nadaVid });
    }
    //If multiple NadaAttributes are returned, check the LegacyNadaValues for one matching the existing NadaVid in state
    //Replace the NadaVid in the state with the corresponding returned NadaVid.
    if (normalizedAttributes.nadaAttributes && normalizedAttributes.nadaAttributes.allIds.length > 1) {
        const existingNadaVid = yield select(getVehicleNadaVid);
        for (const id of normalizedAttributes.nadaAttributes.allIds) {
            const attribute = normalizedAttributes.nadaAttributes.byId[id];
            if (attribute.legacyNadaVid && attribute.legacyNadaVid === existingNadaVid) {
                vehicleStateParam.push({ name: AttributeKeyForVehicle.NADA_VID, value: attribute.nadaVid });
                hasNadaVidMapped = true;
                break;
            }
        }
    }
    //Update vehicle state for Redbook attribute if these are not ambigious
    if (normalizedAttributes.redbookAttributes && normalizedAttributes.redbookAttributes.allIds.length === 1) {
        const redbookControlNumber = normalizedAttributes.redbookAttributes.allIds[0];
        vehicleStateParam.push({ name: AttributeKeyForVehicle.REDBOOK_CONTROL_NUMBER, value: redbookControlNumber });
    }
    yield put(vehicleChangeStateAction({ items: vehicleStateParam, isChangeIgnored: !hasNadaVidMapped }));
}
//# sourceMappingURL=handleAttributesSetToVehicleSaga.js.map